import { render, staticRenderFns } from "./BasicMannersPackageForm.vue?vue&type=template&id=d72dfd48&"
import script from "./BasicMannersPackageForm.vue?vue&type=script&lang=js&"
export * from "./BasicMannersPackageForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicMannersPackageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports